import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'site-modules/shared/components/link/link';
import { Location, StepItem } from 'client/site-modules/financing/constants/models';
import { createLinkForStep } from 'site-modules/shared/utils/car-buying/link-util';
import { FinancingModel, PATHS } from 'client/data/models/financing';

export function StepWrapper({
  href = null,
  isFutureSteps = false,
  children = null,
  className = null,
  ariaLabel = null,
}) {
  if (isFutureSteps) return <div className={className}>{children}</div>;
  return (
    <Link to={href} className={className} aria-label={ariaLabel}>
      {children}
    </Link>
  );
}

StepWrapper.propTypes = {
  href: PropTypes.string,
  isFutureSteps: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export function NavigationStep({
  step,
  activeStep = 'payment',
  index,
  lastVisitedIndex,
  activeStepIndex,
  location,
  setModelValue,
  vin = null,
}) {
  const isActive = activeStep === step.path;
  const isVisited = lastVisitedIndex >= index;
  const isHighlighted = activeStepIndex >= index;

  useEffect(
    () => {
      setModelValue(PATHS.VISITED_STEPS({ vin }), FinancingModel, activeStep);
    },
    /* eslint-disable react-hooks/exhaustive-deps */

    [index, lastVisitedIndex]
  );

  const href = isVisited ? createLinkForStep(activeStep, step.path, location, {}) : '';
  const isFutureSteps = !(isVisited || isActive);

  return (
    <li aria-current={isActive ? 'step' : false}>
      <StepWrapper
        className="d-block text-decoration-none"
        href={href}
        isFutureSteps={isFutureSteps}
        ariaLabel={step.name}
      >
        <div
          className={classNames('step', {
            'bg-primary-darker': !isActive && isHighlighted,
            'bg-primary': isActive && isHighlighted,
            'bg-gray-lighter': !(isActive && isVisited),
          })}
        />
        <div
          className={classNames('mt-1 medium text-center hidden-sm-down', {
            'fw-bold text-primary-darker': (isVisited && isHighlighted) || isActive,
          })}
        >
          {step.name}
          {isVisited ? (
            <>
              <i className="icon-checkmark text-primary-darker ms-0_5" aria-hidden />
              <span className="visually-hidden">(Visited)</span>
            </>
          ) : null}
        </div>
      </StepWrapper>
    </li>
  );
}

NavigationStep.propTypes = {
  lastVisitedIndex: PropTypes.number.isRequired,
  step: StepItem.isRequired,
  index: PropTypes.number.isRequired,
  activeStepIndex: PropTypes.number.isRequired,
  location: Location.isRequired,
  setModelValue: PropTypes.func.isRequired,
  vin: PropTypes.string,
  activeStep: PropTypes.string,
};
